export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10528.b9c6344d.jpg";